import { DomainsSharedTranslationsExtension } from '../Infra';
import { createPremiumModule } from '@wix/premium-fed-sdk/@premium-module';
import { DomainsSharedModalsExtension } from '../modals/sharedModals.extension';
export const DomainsSharedComponentsModule = createPremiumModule('DomainsSharedComponents', [DomainsSharedTranslationsExtension, DomainsSharedModalsExtension]);
//# sourceMappingURL=DomainsSharedComponentsModule.js.map